export default __webpack_public_path__ + "images/NOIE_LOGO_BLACK.png";